import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import { Skeleton } from "antd";

import { Table, Space, Button as AntButton,Tag } from 'antd';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { DatePicker, Form } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);


// var mqtt    = require('mqtt');
// var options = {
//     protocol: 'mqtt',
//     // clientId uniquely identifies client
//     // choose any string you wish
//     clientId: 'b0908853'    
// };
// var client  = mqtt.connect('ws://mqtt.nadunet.es:8083', options);

// var client  = mqtt.connect('ws://nadunet.es:8083');
// client.on('connect', function () {
//   client.subscribe('outTopic', function (err) {
//     if (!err) {
//       client.publish('outTopic', '1');
//     }
//   });
// });
// client.on('message', function (topic, message) {
//   // message is Buffer
//   console.log("--------- MQTT ---------");
//   console.log(message.toString());
//   client.end();
// });

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920
};

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

var messageCounter = 0;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    // var now = moment();
    // var monday = now.clone().weekday(0);
    // var sunday = now.clone().weekday(6);
    let dates = null;
    let filter = this.loadFilter();
    if (filter) {
      dates = filter.dates;
    }
    if (!dates) {
      dates = [dayjs().startOf("week"), dayjs().endOf("week")];
    }
    // console.log("monday, sunday", [monday, sunday]);
    // console.log("dates", dates);
    this.state = {
      servicesSize: "auto",
      customersChartReady: false,
      ordersToDisplayInChart: 6,
      prizeNumber: 0,
      mustSpin: false,
      waitingResult: false,

      assistances: null,
      // date_day_min: monday,
      // date_day_max: sunday,
      filter: {
        dates: dates
      }
    };

    this.redirectTo = this.redirectTo.bind(this);
    
    let externalUsers = [
      "Oniti"
    ];
    if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
      this.props.history.push("/clientes");
    }

    // n.ucleo business logic
    this.buildAssistancesList = this.buildAssistancesList.bind(this);
    this.buildAssistancesFilter = this.buildAssistancesFilter.bind(this);
    this.listAssistances = this.listAssistances.bind(this);
    this.deleteAssistance = this.deleteAssistance.bind(this);
  }
  componentDidMount() {
    // let start = this.state.date_day_min.format("YYYY-MM-DD");
    // let end = this.state.date_day_max.format("YYYY-MM-DD");
    this.listAssistances();
    // client.subscribe('naduhome_1/outTopic');
    // client.on('message', this.updateStatus.bind(this));
    // client.on('connect', () => {
    //   // console.log("");
    //   // console.log("----------------------------------------");
    //   // console.log("------------ MQTT Connected ------------");
    //   // console.log("----------------------------------------");
    //   // console.log("");
    //   // client.publish('inTopic', '0');
    // });
  }
  async listAssistances() {
    const { filter } = this.state;
    console.log("filter in list", filter);
    console.log("this.state", this.state);
    let start = filter.dates[0].format("YYYY-MM-DD");
    let end = filter.dates[1].format("YYYY-MM-DD");
    let _filter = {
      date_from: start,
      date_to: end
    };
    this.setState({ loadingAssistances: true });
    this.props.userData.listAssistances(_filter).then(result => {
      this.setState({ loadingAssistances: false });
      if (result.ok) {
        this.setState({
          assistances: result.assistances,
        });
      } else {
        console.log("Something went wrong listing assistances: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({ loadingAssistances: false });
      // Error 😨
      console.log("Something went wrong listing assistances: " + error.message);
      // console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
    // filter.page = filter.page - 1;
  }
  async deleteAssistance(id) {
    let isDeletingAssistance = this.state.isDeletingAssistance;
    if (this.state.isDeletingAssistance && this.state.isDeletingAssistance[id]) return;
    if (!isDeletingAssistance) isDeletingAssistance = [];
    isDeletingAssistance[id] = true;
    this.setState({
      isDeletingAssistance: isDeletingAssistance
    });
    this.props.userData.deleteAssistance(id).then(result => {
      let isDeletingAssistance = this.state.isDeletingAssistance;
      isDeletingAssistance[id] = false;
      this.setState({
        isDeletingAssistance: isDeletingAssistance
      });
      if (result.ok) {
        this.listAssistances();
        let options = {
          place: "tr",
          message: "Asistencia eliminada",
          type: "danger",
          icon: "now-ui-icons users_single-02",
          autoDismiss: 3
        };
        this.props.userData.showNotification(options);
      } else {
        console.log("Something went wrong: " + result.error);
        let options = {
          place: "tr",
          message: "No se pudo eliminar la asistencia: " + result.error,
          type: "danger",
          icon: "now-ui-icons users_single-02",
          autoDismiss: 3
        };
        this.props.userData.showNotification(options);
      }
    })
    .catch((error) => {
      let isDeletingAssistance = this.state.isDeletingAssistance;
      isDeletingAssistance[id] = false;
      this.setState({
        isDeletingAssistance: isDeletingAssistance
      });
      // Error 😨
      console.log("Error al guardar la asistencia: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });

  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  updateStatus(topic, message) {
    // console.log("------------ MQTT: " + topic + " [" + messageCounter++ + "] ------------");
    // let msg = message.toString();
    // // console.log(msg);
    // this.setState({ message: msg });
  }
  publishChange() {
    // let message = "0";
    // let topic = "naduhome_1/inTopic";
    // if (this.state.message === "0") message = "1";
    // // console.log("------------ MQTT OUT: " + topic + " [" + messageCounter++ + "] ------------");
    // // console.log(message);
    // client.publish(topic, message);
  }
  saveFilter() {
    let filter = Object.assign({}, this.state.filter);
    let dates = [filter.dates[0].toISOString(), filter.dates[1].toISOString()];
    filter.dates = dates;
    console.log("saving filter", filter);
    localStorage.setItem("assistances_filter", JSON.stringify(filter));
  }
  loadFilter() {
    let loaded = localStorage.getItem("assistances_filter");
    if (loaded) {
      loaded = JSON.parse(loaded);
      loaded.dates = [dayjs(loaded.dates[0]), dayjs(loaded.dates[1])];
    }
    console.log("loading filter", loaded);
    return loaded;
  }
  removeFilter() {
    localStorage.removeItem("assistances_filter");
  }
  buildAssistancesList() {
    let assistances = this.state.assistances;
    if (!assistances) return null;
    let assistancesList = Object.values(assistances);
    const columns = [
      {
        title: 'Título',
        dataIndex: 'title',
        key: 'title',
        sorter: (a, b) => a.title.localeCompare(b.title), // This will sort alphabetically
      },
      {
        title: 'Inicio',
        dataIndex: 'start',
        key: 'start',
        sorter: (a, b) => {
          var arrA = a.start.split(/[\s/:]/); // Split by space, slash or colon
          var arrB = b.start.split(/[\s/:]/);
          // Create Date objects for comparison
          var da = new Date(arrA[2], arrA[1]-1, arrA[0], arrA[3], arrA[4]);
          var db = new Date(arrB[2], arrB[1]-1, arrB[0], arrB[3], arrB[4]);
          return da - db; // Subtracting Date objects gives difference in milliseconds
        },
        defaultSortOrder: "ascend"
      },
      // {
      //   title: 'End',
      //   dataIndex: 'end',
      //   key: 'end',
      // },
      {
        title: 'Dirección',
        key: 'street',
        render: (text, record) => {
          return <span>{record.street + ", " + record.locality}</span>;
        }
      },
      {
        title: 'Estado',
        key: 'status',
        render: (text, record) => (
          <Space>
            <Tag color={record.status_color} key={record.id + "-status"}>
              {record.status_name}
            </Tag>
          </Space>
        ),
      },
      // {
      //   title: 'Locality',
      //   dataIndex: 'locality',
      //   key: 'locality',
      // },
      {
        title: 'Acciones',
        key: 'action',
        render: (text, record) => {
          let isDeletingAssistance = this.state.isDeletingAssistance;
          if (isDeletingAssistance && isDeletingAssistance[record.id]) {
            return (
              <Space>
                <AntButton danger loading>
                  Eliminando
                </AntButton>
              </Space>
            );
          }
          if (this.state.deleteAssistance && this.state.deleteAssistance === record.id) {
            return (
              <Space size="middle">
                <span>¿Eliminar?</span>
                <AntButton
                  key={record.id + "-cancel-delete"}
                  onClick={() => {
                    this.setState({ deleteAssistance: null });
                  }}
                >Cancelar</AntButton>
                <AntButton
                  key={record.id + "-confirm-delete"}
                  // icon={<DeleteOutlined />}
                  danger
                  onClick={() => {
                    this.setState({ deleteAssistance: null });
                    this.deleteAssistance(record.id);
                  }}
                >Sí</AntButton>
              </Space>
            );
          } else {
            return (
              <Space size="middle">
                <AntButton
                  key={record.id + "-view"}
                  icon={<EyeOutlined />}
                  onClick={() => {
                    this.redirectTo("/asistencias/" + record.id);
                  }}
                />
                <AntButton
                  key={record.id + "-edit"}
                  icon={<EditOutlined />}
                  onClick={() => {
                    this.redirectTo("/asistencias/editar/" + record.id);
                  }}
                />
                <AntButton
                  key={record.id + "-delete"}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    this.setState({ deleteAssistance: record.id })
                  }}
                />
              </Space>
            );
          }
        },
      },
    ];
    return <Table sorter columns={columns} dataSource={assistancesList} />;
  }
  handleDateChange = dates => {
    let filter = this.state.filter;
    filter.dates = dates;
    this.setState({ filter: filter }, () => {
      this.saveFilter();
      this.listAssistances();
    });
  };
  buildAssistancesFilter() {
    const { filter } = this.state;
    return (
      <Form.Item label="Filtro por fechas">
        <DatePicker.RangePicker
          value={filter.dates}
          onChange={this.handleDateChange}
          format="DD/MM/YYYY"
        />
      </Form.Item>
    );
  }
  render() {
    // if (this.props.userData.isTechnician()) {
    //   return <Redirect to="/citas" />;
    // }
    // console.log(" ESTADO ACTUAL ");
    // console.log(this.state);
    // let mqttButton = 
    //   <Button icon onClick={this.publishChange} color={this.state.message === "1"? "primary" : "danger"}>
    //     <i className="now-ui-icons business_bulb-63" />
    //   </Button>;
    // if (this.props.mainState.customersLastMonthsLoaded && !this.state.customersChartReady) this.loadCustomersChart();
    let assistancesList = this.buildAssistancesList();
    let assistancesFilter = this.buildAssistancesFilter();
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div>
          //     <h6 style={dashboardOrdersTitleStyle}>Evolución clientes</h6>
          //   <Line
          //     data={!this.state.customersChartReady? dashboardPanelChart.data : this.state.customersChart.data}
          //     options={!this.state.customersChartReady? dashboardPanelChart.options : this.state.customersChart.options}
          //   />
          //   </div>
          // }
        />
        <div className="content">
          <Row className="dashboard-buttons">
            <Button
              // icon
              // block
              color="primary"
              onClick={() => {
               this.redirectTo("/asistencias/nueva");
              }}
              // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              leftLabel={"now-ui-icons ui-1_simple-add"}
            >Nueva asistencia</Button> 
          </Row>
          <Row>
            <Card>
              <CardHeader>
                <CardTitle>
                  <div id="assistances-list-icon"><i className="now-ui-icons ui-2_settings-90 icon icon-primary"/></div>{" "}
                  Lista de asistencias{" "}
                  {this.state.loadingAssistances && <Spin indicator={antIcon} />}
                </CardTitle>
              </CardHeader>
              <CardBody>
                {assistancesFilter}
                {assistancesList}
                {this.state.loadingAssistances &&
                  (!this.state.assistances ||
                    this.state.assistances.length === 0) && <Skeleton active />}
              </CardBody>
            </Card>
          </Row>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx